import {addClass, removeClass} from "../_vars";
import {disableScroll} from "./disableScroll.js";
import {enableScroll} from "./enableScroll.js";

export const modalLogic = () => {
   window.activePopup;

   function getSourceFeedback(el) {
      const links = el.querySelectorAll(".reviews-card__link");
      return {
         avatar: el.querySelector(".reviews-card__avatar"),
         name: el.querySelector(".reviews-card__name"),
         link0: links[0],
         link1: links[1],
         desc: el.querySelector(".reviews-card__desc"),
         descFull: el.querySelector(".reviews-card__desc-full"),
      }
   }

   addEventListener("click", (e) => {
      const target = e.target.closest("[data-modal]");
      if (!target) return;
      e.preventDefault();
      const modal = document.querySelector(`.${target.dataset.modal}`);

      if (target.getAttribute("data-modal") === "full-review") {
         const sourceObj = getSourceFeedback(target.closest(".reviews-card"));
         const popupObj = getSourceFeedback(modal);
         popupObj.avatar.innerHTML = sourceObj.avatar.innerHTML;
         popupObj.name.innerHTML = sourceObj.name.innerHTML;
         if (sourceObj.link0) popupObj.link0.innerHTML = sourceObj.link0?.innerHTML;
         if (sourceObj.link1) popupObj.link1.innerHTML = sourceObj.link1?.innerHTML;
         popupObj.desc.innerHTML = sourceObj.descFull.innerHTML;
      }

      addClass(modal, "--show");
      window.activePopup = modal;
      disableScroll();
   });
   const modals = document.querySelectorAll("[data-modal-block]");
   modals.forEach((modal) => {
      if (location.hash.slice(1) === modal.id) {
         addClass(modal, "--show");
         window.activePopup = modal;
         disableScroll();
      }

      const closeModal = modal.querySelector(".modal__close");
      closeModal.addEventListener("click", () => {
         removeClass(modal, "--show")
         history.pushState({}, "", location.href.replace(location.hash, ""));
         const nextLocation = modal.getAttribute("data-next-location");
         if (nextLocation) location.assign(nextLocation);
         setTimeout(enableScroll, 500);
         window.activePopup = undefined;
      }
      );
      modal.addEventListener("click", (e) => {
         const target = e.target;
         const isModal =
            target.hasAttribute("data-modal-block");
         if (isModal) {
            removeClass(modal, "--show");
            history.pushState({}, "", location.href.replace(location.hash, ""));
            const nextLocation = modal.getAttribute("data-next-location");
            if (nextLocation) location.assign(nextLocation);
            setTimeout(enableScroll, 500);
            window.activePopup = undefined;

         }
      });
   });

   addEventListener("popstate", () => {
      if (window.activePopup?.id !== location.hash.slice(1)) {
         if (window.activePopup) {
            removeClass(window.activePopup, "--show");
            const nextLocation = window.activePopup.getAttribute("data-next-location");
            if (nextLocation) location.assign(nextLocation);
         }
         enableScroll();
         window.activePopup = undefined;
      }
      modals.forEach((modal) => {
         if (location.hash.slice(1) === modal.id) {
            addClass(modal, "--show");
            window.activePopup = modal;
            disableScroll();
         }
      });
   })
};
